import { applicationReducer } from "./applications";
import { authReducer } from "./auth";
import { connectionReducer } from "./connection";
import { deletedDeviceReducer } from "./deleted-devices/reducers";
import { deviceStatusReducer } from "./device-statuses";
import { deviceReducer } from "./devices";
import { featureFlagsReducer } from "./feature-flags/reducers";
import { loaderReducer } from "./loader";
import { messagesReducer } from "./messages";
import { networkReducer } from "./networks";
import { userContentsReducer } from "./user-contents/reducers";
import { usersReducer } from "./users";

const globalReducers = {
  applications: applicationReducer,
  auth: authReducer,
  connection: connectionReducer,
  deletedDevices: deletedDeviceReducer,
  devices: deviceReducer,
  deviceStatuses: deviceStatusReducer,
  featureFlags: featureFlagsReducer,
  loader: loaderReducer,
  messages: messagesReducer,
  networks: networkReducer,
  userContents: userContentsReducer,
  users: usersReducer,
};

export { globalReducers };
